import { render, staticRenderFns } from "./wxExport.vue?vue&type=template&id=78adeafa&scoped=true&"
import script from "./wxExport.vue?vue&type=script&lang=js&"
export * from "./wxExport.vue?vue&type=script&lang=js&"
import style0 from "./wxExport.vue?vue&type=style&index=0&id=78adeafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adeafa",
  null
  
)

export default component.exports